import { useMemo } from 'react';

import {
  applySolidCheckoutSubmitButtonColor,
  SolidCheckoutFormStyles,
} from '~/components/organisms/SolidCheckout/formConfig';
import { useIsHomePageRedesignEnabled } from '~/modules/home/useIsHomePageRedesignEnabled';

export const useSolidCheckoutFormStyles = <
  TFormStyles extends SolidCheckoutFormStyles,
>(
  formStyles: TFormStyles,
): TFormStyles => {
  const isHomePageRedesignEnabled = useIsHomePageRedesignEnabled();

  return useMemo(
    () =>
      applySolidCheckoutSubmitButtonColor(formStyles, {
        isHomePageRedesignEnabled,
      }),
    [formStyles, isHomePageRedesignEnabled],
  );
};
